import { useLayoutEffect } from "react";

/**
 * document.titleを設定する。
 *
 * ビルドはReactをpreact/compatへエイリアスしており、React 19の<title>
 * 自動ホイスティングが働かない。JSXへ<title>を置くとheadへ移動せず
 * その場に描画され、タイトル文字列が本文に見えたままdocument.titleも
 * 変わらない。そのためtitleはこのフックから明示的に設定する。
 */
export function useDocumentTitle(title: string): void {
  useLayoutEffect(() => {
    document.title = title;
  }, [title]);
}
